<div class="relative aspect-video w-full bg-ui-surface-rise @5xl:aspect-[3/2]">
  <iframe
    title="Google maps"
    class="absolute inset-0 size-full"
    [src]="path"
    style="border: 0"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade">
  </iframe>
</div>
